import { createFileRoute } from '@tanstack/react-router'
import { requireActiveSubscription, requireRoles } from '@/lib/middleware'
import { BudgetCalculator } from '@/features/budget-calculator'
import z from 'zod'

const budgetCalculatorSearchSchema = z.object({
  page: z.number().optional().catch(1),
  pageSize: z.number().optional().catch(10),
  clientId: z.string().optional().catch(''),
  status: z.string().optional().catch(''),
  search: z.string().optional().catch(''),
})

export const Route = createFileRoute(
  '/_authenticated/_organization/budget-calculator/'
)({
  validateSearch: budgetCalculatorSearchSchema,
  beforeLoad: async () => {
    await requireRoles(['owner', 'admin', 'support_coordinator', 'team_leader'])
    await requireActiveSubscription()
  },
  component: BudgetCalculator,
})
